export interface AcrossProgressUpdate {
  step: string;
  status: string;
  txHash?: `0x${string}`;
}

function isHexTxHash(value: unknown): value is `0x${string}` {
  return typeof value === 'string' && /^0x[a-fA-F0-9]{64}$/.test(value);
}

export function getAcrossProgressUpdate(progress: any): AcrossProgressUpdate {
  const txHash =
    progress?.txReceipt?.transactionHash ??
    progress?.txReceipt?.hash ??
    progress?.txHash ??
    progress?.hash;

  return {
    step: String(progress?.step ?? ''),
    status: progress?.status === 'txSuccess' ? 'success' : String(progress?.status ?? ''),
    txHash: isHexTxHash(txHash) ? txHash : undefined,
  };
}
